import { BLOCKS, INLINES } from '@contentful/rich-text-types'
import { withDisplayName } from '@hocs/with-display-name'
import { documentHeading3Refresh } from '@render-node/document-heading-3-refresh'
import { hyperlink } from '@render-node/hyperlink'
import { paragraphUnification } from '@render-node/paragraph-unification'
import { children } from '@render-node/utils/children'
import RichText from '@resolvers/rich-text'
import { defaultRichTextFieldOptionsDeprecated } from '@resolvers/rich-text/default-rich-text-field-options-deprecated'
import clsx from 'clsx/lite'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulContentArticleRefreshCardStage: Utils.EntryFC<
  Queries.ContentfulContentArticleCardImageFragment
> = ({
  content: { contentArticleTitle: title, content },
  entryInspectorProps,
  fieldInspectorProps,
}) => (
  <div
    className={clsx(
      'flex flex-col rounded-[24px] px-6 py-12 text-[#10190D]',
      'group-[.is-white]/section-template:bg-[#F2F5F2]',
      'group-[.is-premium-black]/section-template:bg-[#FFFFFF10] group-[.is-premium-black]/section-template:text-[#FFFFFF]'
    )}
    {...entryInspectorProps()}
  >
    <div className="mx-auto mb-8 flex h-[60px] w-[60px] items-center justify-center text-[90px] font-medium leading-alternate text-[#8FD448] [counter-increment:content-article] before:[content:counter(content-article)]"></div>
    {title && (
      <RichText
        className="mb-3 text-balance text-center"
        {...fieldInspectorProps({
          fieldId: 'title',
        })}
        content={title}
        options={{
          ...defaultRichTextFieldOptionsDeprecated,
          renderNode: {
            ...defaultRichTextFieldOptionsDeprecated.renderNode,
            [BLOCKS.DOCUMENT]: documentHeading3Refresh,
            [BLOCKS.PARAGRAPH]: children,
          },
        }}
      />
    )}
    {content && (
      <div className="grow self-stretch">
        <RichText
          {...fieldInspectorProps({
            fieldId: 'content',
          })}
          content={content}
          options={{
            ...defaultRichTextFieldOptionsDeprecated,
            renderNode: {
              ...defaultRichTextFieldOptionsDeprecated.renderNode,
              [BLOCKS.PARAGRAPH]: paragraphUnification,
              [INLINES.HYPERLINK]: hyperlink,
            },
          }}
        />
      </div>
    )}
  </div>
)

export const query = graphql`
  fragment ContentfulContentArticleRefreshCardStage on Contentful4TmD9EihHakmKMkEwKaUwQ {
    ...ContentfulEntry
    contentArticleTitle: title {
      ...ContentfulContentArticleTitle
    }
    content {
      ...ContentfulContentArticleContent
    }
  }
`

export default withDisplayName(
  ContentfulContentArticleRefreshCardStage,
  'ContentfulContentArticleRefreshCardStage'
)
